const UPDATE_CONFIRMED_PHONE = `${process.env.API_V4_HOST}/_exclusive/users/confirmed-phone`;

export const getMe = $axios => $axios.$get('/user-profiles');
export const updateConfirmedPhoneNumber = ($axios, params) => {
  const { phoneNumber, changePhoneToken, otpCode, otpMethod } = params;
  const payload = phoneNumber ? { phone_number: phoneNumber, change_phone_token: changePhoneToken } : {};

  const headerOtpMethod = otpMethod.toLowerCase();
  const request = {
    headers: {
      'Bukalapak-OTP-Method': headerOtpMethod,
    },
  };
  if (otpCode) request.headers['Bukalapak-Phone-Token'] = otpCode;

  return $axios.$put(UPDATE_CONFIRMED_PHONE, { ...payload }, { ...request });
};
